module.exports = require("json!langs");;